import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PageService {

    openSidenav = new EventEmitter();

}
